export const IANA_TIMEZONES = [
  'Europe/Rome', 'Europe/Berlin', 'Europe/Paris', 'Europe/Madrid', 'Europe/London',
  'Europe/Amsterdam', 'Europe/Brussels', 'Europe/Vienna', 'Europe/Zurich',
  'UTC',
  'America/New_York', 'America/Chicago', 'America/Los_Angeles',
  'Asia/Dubai', 'Asia/Tokyo', 'Asia/Shanghai',
  'Australia/Sydney',
] as const;
export type IanaTimezone = typeof IANA_TIMEZONES[number];

export const DEFAULT_TIMEZONE: IanaTimezone = 'Europe/Rome';
